<template>

  <div class="mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
        Organization
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200">
        Add the agents in your contact center.
      </h1>
    </div>

    <div class="flex">


      <label class="input input-bordered flex items-center mr-2" style="width:330px">
        <input type="text" v-model="searchValue" class="grow" placeholder="Search" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-4 w-4 opacity-70">
          <path fill-rule="evenodd"
            d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            clip-rule="evenodd" />
        </svg>
      </label>



    </div>
  </div>

  <div
    class="overflow-x-auto text-align ml-3 mt-6 card shadow bg-white dark:bg-gray-800 w-full rounded-md p-3 border dark:border-gray-700 flex"
    style="border-radius: 10px; width:98%;height: 70vh;">
    <button class="button import-button" @click="triggerImport">
      <svg viewBox="0 0 24 24">
        <path d="M5 20h14v-2H5v2zm7-18l-5.5 5.5h4v6h3v-6h4L12 2z" />
      </svg>
      Import JSON
    </button>
    <button class="button export-button hidden" @click="exportData">
      <svg viewBox="0 0 24 24">
        <path d="M5 20h14v-2H5v2zm7-18l-5.5 5.5h4v6h3v-6h4L12 2z" />
      </svg>
      Export Diagram as JSON
    </button>
    <button class="button add-button hidden" @click="openModal(null)">
      <svg viewBox="0 0 24 24">
        <path d="M19 13H13v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>
      Add Division or Contact Center
    </button>
    <div style="width:100%;">
      <button class="btn btn-outline button focus-button" @click="focusGraph">
        <svg viewBox="0 0 24 24">
          <path d="M12 4a8 8 0 100 16 8 8 0 000-16zm1 12h-2v-2h2v2zm0-4h-2V8h2v4z" />
        </svg>
        Focus
      </button>
    </div>

    <div id="tree-container"></div>


  </div>



  <it-modal v-model="showModal">
    <template #body>
      <div class="modal-header">Add {{ modalType }}</div>

      <button class="close-button" @click="closeModal">&times;</button>
      <div class="mb-4"><label for="profileName" class="block text-sm font-medium text-gray-700"
          data-translation-id="profileNameHeader" >Name</label><input type="text" v-model="newNodeName" maxlength="10"
          required="" placeholder="Enter name"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      </div>
      <div class="mb-4" v-if="canSelectType === true"><label for="profileName" class="block text-sm font-medium text-gray-700"
          data-translation-id="profileNameHeader" >Select Type</label>
          <select v-model="newNodeType" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option value="" disabled>Select type</option>
          <option v-for="option in typeOptions" :key="option" :value="option">{{ option }}</option>
        </select>
          
      </div>
      
      
      
      <div class="buttons">
        <button class="btn mr-2" @click="closeModal">Cancel</button>
        <button class="btn" @click="addNode">Add</button>
      </div>
    </template>
  </it-modal>

  <it-modal v-model="isNewEntityModalOpen">
    <template #body>
      <div class="modal-header">Modify {{ currentNodeData.type }}: {{ currentNodeData.name }}</div>

      <button class="close-button" @click="isNewEntityModalOpen=false">&times;</button>
      <div class="mb-4">
        <label for="profileName" class="block text-sm font-medium text-gray-700"
          data-translation-id="profileNameHeader" >Name</label><input type="text" v-model="currentNodeData.name" maxlength="10"
          required="" placeholder="Enter name"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      </div>
      <div class="mb-4" v-if="currentNodeData.type.includes('Team')!=false">
        <label  class="block text-sm mb-2 font-medium text-gray-700"
          data-translation-id="profileNameHeader">Agents</label>
          <div style="width:100%;height: 3rem;" class="flex">
          <SelectPageList placeholder="Select Agents" key-prop="id" label-prop="name" @fetch-data="fetchContactCenters" />
      </div>
      
      </div>
      <hr class="mb-4 mt-4"/>
      <div class="mb-4">
        
        <label  class="block text-sm mb-2 font-medium text-gray-700"
          data-translation-id="profileNameHeader">Users
          <div class="font-sm" style="font-size: 10px;">
          Provide Data Access to:
        </div>
        </label>
          <div style="width:100%;height: 3rem;" class="flex">
          <SelectPageList placeholder="Select Users" key-prop="id" label-prop="name" @fetch-data="fetchContactCenters" />
      </div>
      
      </div>
      
      
      <div class="buttons">
        <button class="btn mr-2" @click="isNewEntityModalOpen=false">Cancel</button>
        <button class="btn" @click="modifyNode">Modify</button>
      </div>
    </template>
  </it-modal>

</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

#tree-container {
  width: 100%;
  height: 600px;

  background-color: #fff;
  border-radius: 8px;
  overflow: auto;
  position: relative;
  margin-top: 20px;
  background-color: #f0f0f0;
  background-image:
    linear-gradient(to right, #ccc 1px, transparent 1px),
    linear-gradient(to bottom, #ccc 1px, transparent 1px);
  background-size: 20px 20px;
  border-radius: 6px;
  overflow: auto;
  position: relative;

}

.button {
  max-width: 100px;
  top: 10px;
  float: right;

  cursor: pointer;
  transition: background-color 0.3s;
  z-index: 10;
}

.button svg {
  margin-right: 5px;
  width: 16px;
  height: 16px;
  fill: currentColor;
  transition: transform 0.3s;
}

.button:hover svg {
  transform: scale(1.2);
}

.export-button {
  right: 120px;
  display: none;
}

.import-button {
  right: 240px;
  display: none;
}

.add-button {
  right: 0px;
  display: none;
}

.focus-button {
  right: 1%;

}

.modal {
  display: flex;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s;
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.3s;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  color: #aaa;
  transition: color 0.3s;
}

.close-button:hover {
  color: #000;
}

.modal-header {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.modal input,
.modal select {
  width: 100%;
  padding: 8px 12px;
  margin: 8px 0;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal .buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.modal .buttons .button {
  margin-left: 10px;
}

.node rect {

  transition: fill 0.3s, stroke 0.3s;
}

.node rect:hover {}

.node text {
  fill: #fff;
  font-size: 12px;
  pointer-events: none;
}

.link {
  fill: none;
  stroke: #ccc;
  stroke-width: 1.5px;
}

.add-icon {
  fill: #fff;
  stroke: #000;
  stroke-width: 1px;
  cursor: pointer;
  transition: fill 0.3s, transform 0.3s;
}

.add-icon:hover {
  fill: #ffeb3b;
  transform: scale(1.2);
}

.add-icon-group {
  cursor: pointer;
}

.add-icon-group:hover .add-icon {
  fill: #ffeb3b;
}

.delete-icon {
  fill: #e74c3c;
  stroke: #c0392b;
  stroke-width: 1px;
  cursor: pointer;
  transition: fill 0.3s, transform 0.3s;
}

.delete-icon:hover {
  fill: #c0392b;
  transform: scale(1.2);
}

.delete-icon-group {
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>
<script setup>
import { ref, onMounted, watch } from 'vue';
import EasyDataTable from "vue3-easy-data-table";
import Multiselect from '@vueform/multiselect'
import { SelectPageList } from 'v-selectpage'
import { cond } from 'lodash';


const searchFields = ["agentCustomID", "agentName", "contactCenters"];
const searchValue = ref("");

const isNewEntityModalOpen = ref(false);
const currentNodeData = ref({
  user:"",
  type:""
});

function modifyNode(){
  isNewEntityModalOpen.value=false;
}

const headers = [
  { text: "ID", value: "agentCustomID", sortable: true },
  { text: "Agent Name", value: "agentName", sortable: true },
  { text: "Contact Centers", value: "contactCenters" },
  { text: "Options", value: "options" }

];

let agentsInfoDebug = ref([
  {
    "agentGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "agentCustomID": "1",
    "agentName": "זוהר נחמה",
    "contactCenters": [{
      "contactCenterName": "מוקד 1",
      "contactCenterGuid": ""
    }],
  },
  {
    "agentGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "agentCustomID": "2",
    "agentName": "יהודה חן",
    "contactCenters": [{
      "contactCenterName": "מוקד 1",
      "contactCenterGuid": ""
    }],
  },
]);



onMounted(() => {
  loadStyle(`
rect{
height: 70px;
}

.vue3-easy-data-table {
  height: 95%;
}
.sp-trigger-container.sp-opened{
  box-shadow:none;
}
   .v-dropdown-trigger{
  width:100% !important;
  }
  .dp__main{
    width:262px;
    height:100%;
  }
    .sp-trigger-container .sp-trigger.sp-chips{
    max-height: 1.8rem;
    overflow: auto;
    }
    .sp-trigger-container{
      height:3rem;
    }
    .dp__main input {
     padding-left:17%;
    border-color: #dadcdf;
    flex-shrink: 1;
    appearance: none;
    height: 3rem;
    width:260px;
    font-size: 1rem;
    line-height: 2;
    line-height: 1.5rem;
    border-radius: var(--rounded-btn, .5rem);
    border-width: 1px;
    
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
    }

    .multiselect{
      height:3rem;
      width: 180px;
      margin-right:1%;
    }
  `);


})

function fetchOrganizationDiagram(){
  return {
    id: 1,
    type: 'Organization',
    name: 'My Organization',
    children: [
        {
        id: 1,
        type: 'Contact Center',
        name: '5G מוקד תמיכה',
        children: [
          
        ]
      }
    ]
  };
}



const organization = ref(fetchOrganizationDiagram());

const nextId = ref(2);

const showModal = ref(false);
const modalType = ref('');
const selectedNode = ref(null);
const newNodeName = ref('');
const newNodeType = ref('');
const canSelectType = ref(false);
const typeOptions = ref([]);
const fileInput = ref(null);
const svgRef = ref(null);
const zoomBehavior = ref(null);

const nodesLinkHeight = 120;

const openModal = (node) => {
  if (node && node.type === 'Team') {
    return;
  }
  selectedNode.value = node;
  if (node === null) {
    modalType.value = 'Division or Contact Center';
    canSelectType.value = true;
    typeOptions.value = ['Division', 'Contact Center'];
  } else if (node.type === 'Organization' || node.type === 'Division') {
    modalType.value = 'Division or Contact Center';
    canSelectType.value = true;
    typeOptions.value = ['Division', 'Contact Center'];
  } else if (node.type === 'Contact Center') {
    modalType.value = 'Team';
    canSelectType.value = false;
  }
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  newNodeName.value = '';
  newNodeType.value = '';
  selectedNode.value = null;
};

const addNode = () => {
  if (newNodeName.value.trim() === '') return;
  let newNode = {};
  if (
    selectedNode.value === null ||
    selectedNode.value.type === 'Organization' ||
    selectedNode.value.type === 'Division'
  ) {
    if (canSelectType.value === true && newNodeType.value !== '') {
      newNode.type = newNodeType.value;
      newNode.children = [];
    } else {
      return;
    }
  } else if (selectedNode.value.type === 'Contact Center') {
    newNode.type = 'Team';
    newNode.children = [];
  }
  newNode.name = newNodeName.value;
  newNode.id = nextId.value++;
  if (selectedNode.value === null) {
    selectedNode.value = organization.value;
  }
  if (selectedNode.value.children === undefined || selectedNode.value.children === null) {
    selectedNode.value.children = [];
  }
  selectedNode.value.children.push(newNode);
  renderTree();
  closeModal();
};

const deleteNode = (id) => {
  if (organization.value.id === id) {
    alert('Cannot delete the root node.');
    return;
  }

  const removeNode = (node, parent) => {
    if (node.children === undefined || node.children === null) return false;
    const index = node.children.findIndex(child => child.id === id);
    if (index !== -1) {
      node.children.splice(index, 1);
      return true;
    }
    let child;
    for (let i=0;i<node.children.length;i++) {
      child=node.children[i];
      if (removeNode(child, node) != undefined) {
        return true;
      }
    }
    return false;
  };

  removeNode(organization.value, null);
  renderTree();
};

const wrapText = (text, width, svg) => {
  const words = text.split(/\s+/).reverse();
  let line = [];
  let lineNumber = 0;
  const lineHeight = 0.9;

  const textElement = svg.append("text")
    .attr("x", 0)
    .attr("y", 0)
    .attr("text-anchor", "middle")
    .attr("fill", "#fff")
    .style("font-size", "12px");

  let tspan = textElement.append("tspan")
    .attr("x", 0)
    .attr("y", 0)
    .attr("dy", "0em");

  while (words.length > 0) {
    const word = words.pop();
    line.push(word);
    tspan.text(line.join(' '));
    if (tspan.node().getComputedTextLength() > width - 20 && line.length > 1) {
      line.pop();
      tspan.text(line.join(' '));
      line = [word + " "];
      tspan = textElement.append("tspan")
        .attr("x", 0)
        .attr("y", lineNumber++ * lineHeight + "em")
        .attr("dy", "0.9em")
        .text(word);
    }
  }
};

const renderTree = () => {
  const data = organization.value;

  const container = d3.select("#tree-container");
  container.selectAll("*").remove();

  const svgWidth = container.node().clientWidth;
  const svgHeight = container.node().clientHeight;

  const svg = container.append("svg")
    .attr("width", svgWidth)
    .attr("height", svgHeight)
    .call(d3.zoom().on("zoom", function (event) {
      svgGroup.attr("transform", event.transform);
    }));



  svgRef.value = svg;

  const svgGroup = svg.append("g")
    .attr("transform", "translate(0,0)");



  zoomBehavior.value = d3.zoom().on("zoom", function (event) {
    svgGroup.attr("transform", event.transform);
  });

  const root = d3.hierarchy(data);

  const treeLayout = d3.tree()
    .nodeSize([220, nodesLinkHeight])
    .separation((a, b) => a.parent === b.parent ? 1 : 2);

  treeLayout(root);

  svgGroup.selectAll('.link')
    .data(root.links())
    .enter()
    .append('path')
    .attr('class', 'link')
    .attr('d', d3.linkVertical()
      .x(d => d.x)
      .y(d => d.y))
    .attr('fill', 'none')
    .attr('stroke', '#ccc')
    .attr('stroke-width', 1.5);

  const node = svgGroup.selectAll('.node')
    .data(root.descendants())
    .enter()
    .append('g')
    .attr('class', 'node')
    .attr('transform', d => `translate(${d.x},${d.y})`)
    .style('cursor', 'pointer');

  const cardWidth = 200;
  const cardHeight = 60;
  const cardRadius = 10;
  const cardFill = '#ffffff';
  const cardStroke = '#ddd';
  const cardStrokeWidth = 1.5;
  const cardShadow = '2px 2px 5px rgba(0,0,0,0.1)';

  node.append('rect')
    .attr('width', cardWidth)
    .attr('height', cardHeight)
    .attr('x', -cardWidth / 2)
    .attr('y', -cardHeight / 2)
    .attr('rx', cardRadius)
    .attr('ry', cardRadius)
    .attr('fill', cardFill)
    .attr('stroke', cardStroke)
    .attr('stroke-width', cardStrokeWidth)
    .style('filter', `drop-shadow(${cardShadow})`)
    .on('mouseover', function () {
      d3.select(this)
        .attr('stroke', '#000')
        .attr('stroke-width', 2);
    })
    .on('mouseout', function () {
      d3.select(this)
        .attr('stroke', cardStroke)
        .attr('stroke-width', cardStrokeWidth);
    })
    .on('dblclick', () => {
      openModal(d.data);
    });


  node.append('text')
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('fill', '#333')
    .style('font-size', '12px')
    .style('font-weight','bold')

    
    .text(d => `${d.data.type}: ${d.data.name}`);

  const maxNodeWidth = 150;

  node.each(function (d) {
    const g = d3.select(this);
    const fullText = `${d.data.type}: ${d.data.name}`;

    const tempText = svg.append("text")
      .attr("x", -maxNodeWidth / 2)
      .attr("y", -10)
      .attr("font-size", "28px")
      .text(fullText);

    let textWidth = tempText.node().getComputedTextLength();
    tempText.remove();

    g.on("click",function(){
      currentNodeData.value=d.data;
      isNewEntityModalOpen.value=true;
    });

    let nodeWidth = textWidth + 40;
    if (nodeWidth > maxNodeWidth) {
      nodeWidth = maxNodeWidth;
    }

    const lineHeight = 0.9;
    const words = fullText.split(/\s+/);
    const lines = [];
    let currentLine = "";

    words.forEach(word => {
      const testLine = currentLine + word + " ";
      const temp = svg.append("text")
        .attr("x", -nodeWidth / 2)
        .attr("y", -10)
        .attr("font-size", "12px")
        .text(testLine);
      const testWidth = temp.node().getComputedTextLength();
      temp.remove();
      if (testWidth > nodeWidth - 20 && currentLine !== "") {
        lines.push(currentLine.trim());
        currentLine = word + " ";
      } else {
        currentLine = testLine;
      }
    });
    lines.push(currentLine.trim());

    const nodeHeight = 20 + lines.length * lineHeight * 14;





    g.append('g')
      .attr('class', 'delete-icon-group')
      .attr('transform', `translate(${nodeWidth / 2 - 10},${-nodeHeight / 2 + 10})`)
      .on('click', (event) => {
        event.stopPropagation();
        deleteNode(d.data.id);
      });



    g.selectAll('.delete-icon-group')
      .append('text')
      .attr('class', 'delete-icon-text')
      .attr('dy', 3)
      .attr('text-anchor', 'middle')
      .text('✖')
      .attr('fill', '#fff')
      .attr('pointer-events', 'none')
      .style('font-size', '10px');

    if (d.data.type !== 'Team') {
      g.append('g')
        .attr('class', 'add-icon-group')
        .attr('transform', `translate(0, ${nodeHeight / 2 + 15})`)
        .on('click', (event) => {
          event.stopPropagation();
          openModal(d.data);
        })
        .style('cursor', 'pointer');

      g.selectAll('.add-icon-group')
        .append('circle')
        .attr('class', 'add-icon')
        .attr('r', 13)
        .attr('cx', 0)
        .attr('cy', 0)
        .attr('fill', '#ffff')
        .attr('stroke', '#ddd')
        .attr('stroke-width', 0.5);

      g.selectAll('.add-icon-group')
        .append('text')
        .attr('class', 'add-icon-text')
        .attr('dy', 4)
        .attr('text-anchor', 'middle')
        .text('+')
        .attr('fill', '##352f2f')
        .attr('pointer-events', 'none')
        .style('font-size', '12px');

    }
  });

  svgGroup.selectAll('.link')
    .data(root.links())
    .join('path')
    .attr('class', 'link')
    .attr('d', d3.linkVertical()
      .x(d => d.x)
      .y(d => d.y))
    .attr('fill', 'none')
    .attr('stroke', '#ccc')
    .attr('stroke-width', 1.5);
};

const exportData = () => {
  const dataStr = JSON.stringify(organization.value, null, 2);
  const blob = new Blob([dataStr], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "organization_data.json";
  link.click();
  URL.revokeObjectURL(url);
};

const triggerImport = () => {
  fileInput.value.click();
};

const importData = (event) => {
  const file = event.target.files[0];
  if (file === undefined || file === null) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = JSON.parse(e.target.result);
      if (data.id === undefined || data.id === null) {
        data.id = nextId.value++;
      }
      assignIds(data);
      organization.value = data;
      renderTree();
      focusGraph();
    } catch (error) {
      alert('Invalid JSON file');
    }
  };
  reader.readAsText(file);
};

const assignIds = (node) => {
  if (node.id === undefined || node.id === null) {
    node.id = nextId.value++;
  }
  if (node.children !== undefined && node.children !== null) {
    node.children.forEach(child => assignIds(child));
  }
};

const focusGraph = () => {
  if (svgRef.value != undefined && zoomBehavior.value != undefined) {
    const svgWidth = parseFloat(svgRef.value.attr('width'));
    const svgHeight = parseFloat(svgRef.value.attr('height'));

    const g = svgRef.value.select('g');
    const bounds = g.node().getBBox();
    const dx = bounds.x + bounds.width / 2;
    const dy = bounds.y + bounds.height / 2;

    const scale = Math.min(1, Math.min(svgWidth / (bounds.width + 100), svgHeight / (bounds.height + 100)));

    const translate = [
      svgWidth / 2 - scale * dx,
      svgHeight / 2 - scale * dy
    ];

    const transform = d3.zoomIdentity
      .translate(translate[0], translate[1])
      .scale(scale);

    svgRef.value.transition()
      .duration(750)
      .call(zoomBehavior.value.transform, transform);
  }
};

onMounted(() => {
  renderTree();
  focusGraph();
});

watch(organization, () => {
  renderTree();
  focusGraph();
}, { deep: true });

function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet != null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}




</script>
